"use strict";
exports.__esModule = true;
exports.SUPPORTED_POSITIONS = exports.AUTO = exports.BOTTOM = exports.TOP = exports.RIGHT = exports.LEFT = void 0;
// (C) 2007-2020 GoodData Corporation
exports.LEFT = "left";
exports.RIGHT = "right";
exports.TOP = "top";
exports.BOTTOM = "bottom";
exports.AUTO = "auto";
exports.SUPPORTED_POSITIONS = [exports.BOTTOM, exports.LEFT, exports.RIGHT, exports.TOP];
//# sourceMappingURL=PositionTypes.js.map